import { PersonModel } from "../../person/models/person.model";
import { Observable } from "rxjs/Observable";
import { IAPIResponse, WeGoConfig } from "../../shared/config";
import { RequestOptions, Http, Headers } from "@angular/http";
import { Injectable } from "@angular/core";
import { AuthService } from "../../shared/models/auth.service";
import { SignupModel } from "./signup.model";
import { BatchUploadPersonModel } from "../../batchuploadperson/model/batch-upload-person.model";

@Injectable()
export class SignupService {
  constructor(private authService: AuthService, private http: Http) { }

  public SignUp(signUpModel: SignupModel, lang: string): Observable<IAPIResponse> {
    let body = signUpModel;
    let headers = new Headers({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Accept-Language': lang ? lang : 'en'
    });

    let options = new RequestOptions({ headers: headers });

    return this.http.post(WeGoConfig.API_POST_SIGNUP_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ImportPersonRecord(batchUploadPersonModel: BatchUploadPersonModel): Observable<IAPIResponse> {
    let body = batchUploadPersonModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.post(WeGoConfig.API_IMPORT_BATCH_UPLOAD_CSV, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/signup/models/signup.service.ts